import React from 'react';
import 'twin.macro';
import { useTranslation } from 'react-i18next';
import { TRANSFER_DETAILS } from '.';

export function MandatePayment() {
  const { t } = useTranslation(['userSettings']);

  return (
    <div tw="p-4 bg-white rounded-lg text-neutral-moderate text-sm space-y-4">
      <p>
        {t('userSettings:schoolSubscription.payByBankTransfer.mandate.intro')}
      </p>
      <p>
        {t(
          'userSettings:schoolSubscription.payByBankTransfer.mandate.instructions',
        )}{' '}
        <a
          href={`mailto:${TRANSFER_DETAILS.email}?subject=Demande%20facture%20via%20Chorus`}
          target="_blank"
        >
          {TRANSFER_DETAILS.email}
        </a>{' '}
        :
      </p>
      <ul tw="list-disc list-inside my-4 text-sm">
        <li>
          {t(
            'userSettings:schoolSubscription.payByBankTransfer.mandate.requiredInfo.item1',
          )}
        </li>
        <li>
          {t(
            'userSettings:schoolSubscription.payByBankTransfer.mandate.requiredInfo.item2',
          )}
        </li>
      </ul>
      <p>
        {t(
          'userSettings:schoolSubscription.payByBankTransfer.mandate.confirmationMessage',
        )}
        <br />
        {t(
          'userSettings:schoolSubscription.payByBankTransfer.mandate.activationMessage',
        )}
      </p>
    </div>
  );
}
